<!-- TABLE -->
<table class="table cx-order-history-table">
  <thead class="cx-order-history-thead-mobile">
    <th scope="col" class="ordernumber">
      {{ 'customOrderHistory.orderNumber' | cxTranslate }}
    </th>
    <th scope="col" class="status">
      {{ 'customOrderHistory.status' | cxTranslate }}
    </th>
    <th scope="col" class="deliveryaddress">
      {{ 'customOrderHistory.deliveryAddress' | cxTranslate }}
    </th>
    <th scope="col" class="date">
      {{ 'customOrderHistory.date' | cxTranslate }}
    </th>
    <th scope="col" class="planneddelivery">
      {{ 'customOrderHistory.plannedDelivery' | cxTranslate }}
    </th>
    <th scope="col" class="valutadate">
      {{ 'customOrderHistory.valutaDate' | cxTranslate }}
    </th>
    <th scope="col" class="customerreference">
      {{ 'customOrderHistory.customerReference' | cxTranslate }}
    </th>
    <th scope="col" class="shippingcosts">
      {{ 'customOrderHistory.shippingCosts' | cxTranslate }}
    </th>
    <th scope="col" class="totalprice">
      {{ 'customOrderHistory.totalPrice' | cxTranslate }}
    </th>
    <th scope="col" class="cancel"></th>
  </thead>
  <tbody>
    @for (order of orders; track order) {
      <tr (click)="goToOrderDetail(order)">
        <!--SAP Order Number-->
        <td class="code">
          <div class="d-md-none cx-order-history-label">
            {{ 'customOrderHistory.orderNumber' | cxTranslate }}
          </div>
          <div class="cx-order-history-value">
            <a
            [routerLink]="
              {
                cxRoute: 'orderDetails',
                params: order
              } | cxUrl
            "
              class="cx-order-history-value"
              >
              {{ order?.code }}
              @if (order?.textReLs) {
                <br /><br />
                <span class="textrels">{{
                  'customOrderHistory.textReLs' | cxTranslate
                  }}</span
                  ><br />
                  {{ order?.textReLs }}
                  }</a
                  >
                </div>
              </td>
              <!--Order Status-->
              <td class="status">
                <div class="d-md-none cx-order-history-label">
                  {{ 'customOrderHistory.status' | cxTranslate }}
                </div>
                <div class="cx-order-history-value">
                  <img
              src="assets/images/orderhistory/state_{{
                order?.state | lowercase
              }}.gif"
                    alt="{{ order?.state }}"
                    title="{{ 'customOrderHistory.states.' + order?.state | cxTranslate }}"
                    />
                  </div>
                </td>
                <!--Order Delivery Address-->
                <td class="delivery-address">
                  <div class="d-md-none cx-order-history-label">
                    {{ 'customOrderHistory.deliveryAddress' | cxTranslate }}
                  </div>
                  <div class="cx-order-history-value">
                    {{ order?.deliveryAddress.name1 }}<br />
                    {{ order?.deliveryAddress.name2 }}<br />
                    @if (order?.deliveryAddress.name3) {
                      {{ order?.deliveryAddress.name3 }}<br />
                    }
                    @if (order?.deliveryAddress.name4) {
                      {{ order?.deliveryAddress.name4 }}<br />
                    }
                    {{ order?.deliveryAddress.street }}<br />
                    {{ order?.deliveryAddress.postalCode }}
                    {{ order?.deliveryAddress.city }}
                  </div>
                </td>
                <!--Order Date-->
                <td class="date">
                  <div class="d-md-none cx-order-history-label">
                    {{ 'customOrderHistory.date' | cxTranslate }}
                  </div>
                  <div class="cx-order-history-value">
                    {{ order?.formattedOrderDate }}
                  </div>
                </td>
                <!--Planned Delivery Week-->
                <td class="planned-delivery">
                  <div class="d-md-none cx-order-history-label">
                    {{ 'customOrderHistory.plannedDelivery' | cxTranslate }}
                  </div>
                  <div class="cx-order-history-value">
                    {{ order?.deliverKW | cxDate: 'w/yyyy' }}
                  </div>
                </td>
                <!--Valute Date-->
                <td class="valuta-date">
                  <div class="d-md-none cx-order-history-label">
                    {{ 'customOrderHistory.valutaDate' | cxTranslate }}
                  </div>
                  <div class="cx-order-history-value">
                    {{ order?.formattedValutaDate  }}
                  </div>
                </td>
                <!--Customer Reference-->
                <td class="customer-reference">
                  <div class="d-md-none cx-order-history-label">
                    {{ 'customOrderHistory.customerReference' | cxTranslate }}
                  </div>
                  <div class="cx-order-history-value">
                    {{ order?.customerReference }}
                  </div>
                </td>
                <!--Shipping costs-->
                <td class="shipping-costs">
                  <div class="d-md-none cx-order-history-label">
                    {{ 'customOrderHistory.shippingCosts' | cxTranslate }}
                  </div>
                  <div class="cx-order-history-value">
                    {{ order?.shippingCostsData?.formattedValue }}
                  </div>
                </td>
                <!--Total price-->
                <td class="total-price">
                  <div class="d-md-none cx-order-history-label">
                    {{ 'customOrderHistory.totalPrice' | cxTranslate }}
                  </div>
                  <div class="cx-order-history-value">
                    {{ order?.totalPriceData?.formattedValue }}
                  </div>
                </td>
                <!--Cancel Order-->
                @if (canEdit) {
                  <td class="cancel-order">
                    <div class="d-md-none cx-order-history-label">
                    </div>
                    <div class="cx-order-history-value">
                      @if (order.cancelable) {
                        <a
                          class="delete"
            title="{{
              'customOrderHistory.buttons.cancel' | cxTranslate
            }}"
                          (click)="onCancelOrder($event, order.code)">
                          <cx-icon type="TRASH"></cx-icon>
                        </a>
                      }
                    </div>
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
